
import { Check } from '@educaplay/core/Icons/Check';
import classes from './CheckButton.module.scss';
import { useTranslate } from "@educaplay/core";
import clsx from 'clsx';
import { motion } from 'framer-motion';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';

export default forwardRef(function CheckButton(props, ref) {
    const { onClick, focusNote } = props;
    const t = useTranslate();
    const isCompleteEntryAnimation = useSelector(state => state.game.isCompleteEntryAnimation);

    return (
        <motion.div
            initial={{ y: "200%" }}
            className={clsx(classes.buttoncontainer, focusNote && classes.displaymobile)}
            ref={ref}
        >
            <button
                disabled={!isCompleteEntryAnimation}
                className={classes.button}
                onClick={onClick}
            >
                <span className={classes.icon}><Check /></span>
                <span className={classes.text}>{t("specific.check")}</span>
            </button>
        </motion.div>

    )
})